import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { GetLatestApplicationVersion } from "../../../services/admin/index";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const [version, setVersion] = useState("");

  useEffect(() => {
    const loadVersion = async () => {
      try {
        const response = await GetLatestApplicationVersion(1);

        if (response?.data) {
          setVersion(response.data.versionNumber);
        }
      } catch (error) {
        console.error("Error fetching application version:", error);
        setVersion("2.0");
      }
    };

    loadVersion();
  }, []);

  return (
    <Box sx={{ p: 3, textAlign: "center" }}>
      <Typography>
        Version {version} © {currentYear} All rights reserved by S.S. White Technologies India PVT. Ltd.
      </Typography>
    </Box>
  );
};

export default Footer;